import { forwardRef, type HTMLAttributes } from "react";
import { cn } from "@/lib/utils";

export interface GlassCardProps extends HTMLAttributes<HTMLDivElement> {
  noPadding?: boolean;
}

const GlassCard = forwardRef<HTMLDivElement, GlassCardProps>(
  ({ className, noPadding, children, ...props }, ref) => (
    <div
      ref={ref}
      className={cn(
        "bg-sc-surface backdrop-blur-[24px] border border-sc-glass-border rounded-card",
        "shadow-sc transition-all duration-300",
        "hover:shadow-sc-hover hover:bg-sc-surface-hover",
        noPadding ? "p-0" : "p-6",
        className,
      )}
      {...props}
    >
      {children}
    </div>
  ),
);
GlassCard.displayName = "GlassCard";

export { GlassCard };
